export default __webpack_public_path__ + "static/media/adifund-logo.47c457e1.svg";